import { IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaireItemDividerClass } from '../../../../../core/services/formulaire/formulaire-item-divider.service';
import { IMenuItemForageClass } from "../../../../../core/services/menu/menu-item-forage.service";
import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IMenuClass } from "../../../../../core/services/menu/menu.service";
import { IMenuItemFactoryClass } from '../../../../../core/services/menu/menu-item-factory.service';

interface IPageRc0010 {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
}


/* @ngInject */
export default function Rc0010Controller(Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    MenuItemForage: IMenuItemForageClass,
    Menu: IMenuClass,
    MenuItemFactory: IMenuItemFactoryClass,
    rc2003Route: IRoute,
    rc2004Route: IRoute,
    FormulaireItemDivider: IFormulaireItemDividerClass) {
    const vm: IPageRc0010 = this;

    vm.multiOccurrenceOptions = {
        actionsMoreLigne: new Menu([
            new MenuItemForage('LBL_FAC',
                rc2003Route.NAME,
                (data: any) => ({
                    txmcleint: data.txmcleint
                }),
                {
                    icon: 'view_list',
                    iconButton: false
                }),
            new MenuItemForage('LBL_ITEM_REC',
                rc2004Route.NAME,
                (data: any) => ({
                    txmcleint: data.txmcleint
                }),
                {
                    icon: 'view_list',
                    iconButton: false
                })
        ]),
        fonctions: {
            rechercheCollapsable: false,
            reinitialiserOuvrirCriteres: false,
            effaceCriteres: false,
            criteresSuggeresVisibles: true
        },
        criteresSuggeres: new Formulaire([
            new FormulaireItem('refcleint', { required: false }),
            new FormulaireItem('tydcleint', { required: false }),
            new FormulaireItem('intcleintreq', { required: false }),
            new FormulaireItem('lrtcleint', {
                resourceParams: (data: any) => ({
                    refcleint: data.refcleint,
                    tydcleint: data.tydcleint
                })
            }),
            new FormulaireItem('txmcleint', {
                required: false,
                resourceParams: (data: any) => ({
                    refcleint: data.refcleint,
                    lrtcleint: data.lrtcleint,
                    tydcleint: data.tydcleint
                })
            }),
            new FormulaireItem('docref', {
                resourceParams: (data: any) => ({
                    refcleint: data.refcleint,
                    lrtcleint: data.lrtcleint,
                    tydcleint: data.tydcleint,
                    txmcleint: data.txmcleint
                })
            }),
            new FormulaireItem('datdeb'),
            new FormulaireItem('sysboncmd', {
                resourceParams: (data: any) => ({
                    refcleint: data.refcleint,
                    lrtcleint: data.lrtcelint,
                    tydcleint: data.tydcleint,
                    txmcleint: data.txmcleint
                })
            }),
            new FormulaireItem('datfin'),
            new FormulaireItem('optrup', {
                 default: 3
            }),
            new FormulaireItem('optruprec', {
                 default: 3
            }),
            new FormulaireItem('optfac', {
                largeur: 20,
                  default:1
            }),
            new FormulaireItem('flg_fr', { default: 1 }),
            new FormulaireItem('flg_an', { default: 1 })
        ]),

        actionsRangeeDroite: new Menu([
            new MenuItemFactory(getForageItem)
        ]),
        colonnesCachees: [
            'ecrcodd',
            'ecrcodt',
            'daccleint',
            'txmcleint',
            'doccleintref',
            'doccleintdac'
        ],
        colonnesVisibles: [
            { nom: 'txmnumdoc', largeur: 100 },
            { nom: 'txmnumdocseq', largeur: 100 },
            { nom: 'txmnumref', largeur: 150 },
            {
                nom: 'dacnumdoc', largeur: 146,
                menu: [
                    new MenuItemForage(
                        '',
                        (data: any) => `secure.${data.ecrcodd}.ecran`,
                        (data: any) => ({
                            id: data.doccleintdac,
                            indfor: 1
                        }),
                        {
                            icon: 'launch',
                            iconButton: true
                        }
                    )
                ]
            },
            { nom: 'refcod', largeur: 130 },
            { nom: 'refnom', largeur: 180 },
            { nom: 'tydcod', largeur: 150 },
            { nom: 'tyddsc', largeur: 190 },
            { nom: 'etddsc', largeur: 130 },
            { nom: 'peccod', largeur: 120 },
            { nom: 'txmdat', largeur: 110 },
            { nom: 'intcodreq', largeur: 110 },
            { nom: 'intnomreq', largeur: 180 },
            { nom: 'lipcod', largeur: 140 },
            { nom: 'lipnom', largeur: 160 }
        ],
        colonnesFixesDroite: [
            { nom: 'txmflgrup', largeur: 100 },
            { nom: 'txmflgruprec', largeur: 100 },
            { nom: 'complet', largeur: 100 },
            { nom: 'nbrfac', largeur: 100 }
        ],
    };

    function getForageItem() {
        return new MenuItemForage(
            'BTN_FORAGE',
            (data: any) => (`secure.${data.ecrcodt}.ecran`),
            (data: any) => ({
                id: data.doccleintref,
                indfor: 1
            })
        )
    }
}
